<template>

<div v-if='isReady' class="page-header-info profile-header-info shadow-lg pr-4 pl-4 pt-3 pb-3 mb-5">
    <div class="row d-flex justify-content-center">
        <div class="col-md-3 col-sm-6 d-flex align-items-center justify-content-md-center border-responsive">
            <span class="num">{{ stats.cmp_won }}</span>
            <span class="text">
                <span class="d-inline d-md-block">спечелени </span> 
                <span class="d-inline d-md-block">конкурси</span>
            </span>
        </div>
        <div class="col-md-3 col-sm-6 d-flex align-items-center justify-content-md-center border-responsive">
            <span class="num">{{ stats.cmp_top }}</span>
            <span class="text">
                <span class="d-inline d-md-block">в челните </span>
            <span class="d-inline d-md-block">места</span>
            </span>
        </div>
        <div class="col-md-3 col-sm-6 d-flex align-items-center justify-content-md-center border-responsive">
            <span class="num">{{ stats.auc_won }}</span>
            <span class="text">
                <span class="d-inline d-md-block">спечелени </span>
                <span class="d-inline d-md-block">търгове</span>
            </span>
        </div>
        <div class="col-md-3 col-sm-6 d-flex align-items-center justify-content-md-center">
            <span class="num">{{ stats.auc_succ }}</span>
            <span class="text">
                <span class="d-inline d-md-block">изпълнени </span>
                <span class="d-inline d-md-block">поръчки</span>
            </span>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
            if( typeof this.u != 'undefined' && !isNaN(this.u) ) {
                this.user = this.u;
            }
        },

        props : ['u'],

        data() {
            return {

                isReady : false,
                stats   : false,
                user    : null,

            }
        },

        methods : {

            getData() {

                var me = this;

                me.ajax.call('usr:gus', { u : this.user }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        me.stats = r.data;
                        me.isReady = true;

                    }

                })
            }

        }

    }
</script>
